import { combineReducers } from 'redux'
import configurationData from './configuration'
import destinationsData from './destinations'
import filtersData from './filters'
import searchResultsData from './searchResults'
import sortingData from './sorting'
import toursData from './tours'

const rootReducer = combineReducers({
  configurationData,
  destinationsData,
  filtersData,
  searchResultsData,
  sortingData,
  toursData
})

export default rootReducer
